import { auth } from '@/firebase'
import firebase from 'firebase/app'
import axios from 'axios'
import router from '@/router'
const loginUrl = 'https://us-central1-videojuego-sh.cloudfunctions.net/loginPlayer'

export default {

    async signIn (user) {
        const email = user.email
        const password = user.pass

        try {
            await auth.signInWithEmailAndPassword(email, password)

            if (auth.currentUser) {
                if (auth.currentUser.emailVerified) {
                    // auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
                    auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                } else {
                    this.signOut()
                    console.log('Verifica tu email')
                    alert('Verifica tu email')
                    // Verifica tu email
                }
            }
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
        }
    },

    async signOut () {
        auth.signOut().then(function () {
            router.push({ name: 'Home' }).catch(() => { })
        }).catch(function (error) {
            console.log(error.code)
        })
    },

    async sendForgotEmail (email) {
        try {
            await firebase
                .auth()
                .sendPasswordResetEmail(email)

            alert('Enlace enviado, revise su correo.')
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
            return 'error'
        }
    },

    async updateUser (data) {
        try {
            var users = firebase.firestore().collection('users').doc(data.uid)
            users.update({
                firstname: data.firstname,
                lastname: data.lastname,
                birth_date: data.birth_date,
                location: data.location,
            })

            var us = firebase.auth().currentUser
            us.updateProfile({
                name: `${data.firstname} ${data.lastname}`,
            })

            return 'Ok'
        } catch (error) {
            return `Error updating document: , ${error}`
        }
    },

    async updateNotifications (data) {
        try {
            var users = firebase.firestore().collection('users').doc(data.uid)
            users.update({
                notifications: data.notifications,
            })
            return 'Ok'
        } catch (error) {
            return `Error updating document: , ${error}`
        }
    },

    async updateInvitationStudent (data) {
        try {
            var student = firebase.firestore().collection('users').doc(data.studentId)
            const getStudent = await student.get()
            const tutorExtraPermission = getStudent.data().tutor_extra_permission

            if (data.confirmated) {
                tutorExtraPermission.confirmated = true
                student.update({
                    tutor_extra_permission: tutorExtraPermission,
                })
            } else {
                student.update({
                    tutor_extra: '',
                    tutor_extra_permission: {},
                })
            }

            return 'Ok'
        } catch (error) {
            return `Error updating document: , ${error}`
        }
    },

    async getUser (user) {
        try {
            const response = await firebase
                .firestore()
                .collection('users')
                .doc(user.uid)
                .get()

            const data = response.data()

            var userInfo = {
                nickname: data.nickname,
                name: `${data.firstname} ${data.lastname}`,
                type: data.type,
            }

            // if (data.type === 'student') {
            //     router.push({ name: 'Información de Episodio', params: { id: 0 } })
            // } else if (data.type === 'admin') {
            //     router.replace({ path: '/admin/statistics' })
            // } else {
            //     router.push({ name: 'Estudiantes' })
            // }
            //window.history.length > 1 ? router.go(-1) : router.push('/')

            return Object.assign(userInfo, user)
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
            return 'error'
        }
    },

    async register (userRegister) {
        try {
            const response = await auth.createUserWithEmailAndPassword(userRegister.email, userRegister.password)
            // auth/email-already-in-use
            userRegister.uid = response.user.uid
            this.sendEmail(response.user)
            this.loginPost(userRegister)
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
        }
    },

    async updatePass (newPassword) {
        try {
            var user = firebase.auth().currentUser
            user
                .updatePassword(newPassword)

            alert('Contraseña actualizada con éxito!')
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
        }
    },

    async sendEmail (user) {
        try {
            await user.sendEmailVerification()
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
        }
    },

    async loginPost (userRegister) {

        var education = {
            institution: userRegister.institution,
            school: userRegister.school,
            phone: userRegister.phone,
            address: userRegister.address,
            district: userRegister.district,
            email_contact: userRegister.email_contact,
        }

        try {
            const response = await axios
                .post(loginUrl, {
                    user_id: userRegister.uid,
                    email: userRegister.email,
                    firstname: userRegister.firstname,
                    lastname: userRegister.lastname,
                    nickname: userRegister.nickname,
                    birth_date: userRegister.birth_date,
                    type: userRegister.type,
                    location: userRegister.location,
                    education,
                })
            alert('Gracias por registrarse, porfavor verifique su correo.')
            console.log(response)
            router.push({ name: 'Home' }).catch(() => { })
        } catch (error) {
            var errorCode = error.code
            var errorMessage = error.message
            console.log(errorCode, errorMessage)
            this.errorCode(errorCode)
        }
    },

    errorCode (error) {
        let msjAlert = null
        switch (error) {
            case 'auth/user-not-found':
                msjAlert = 'Email no se encuentra registrado'
                console.log(msjAlert)
                alert(msjAlert)
                break
            case 'auth/wrong-password':
                msjAlert = 'Error en contraseña.'
                console.log(msjAlert)
                alert(msjAlert)
                break
            case 'auth/network-request-failed':
                msjAlert = 'Se ha producido un error de red'
                console.log(msjAlert)
                alert(msjAlert)
                break
            case 'auth/invalid-email':
                msjAlert = 'Error en email'
                console.log(msjAlert)
                alert(msjAlert)
                break
            case 'auth/email-already-in-use':
                msjAlert = 'La dirección de correo electrónico ya está siendo utilizada por otra cuenta.'
                console.log(msjAlert)
                alert(msjAlert)
                break
            default:
                console.log(error)
                break
        }
    },

}
